<script>
import Icon from '../icon';

export default {
  components: {
    Icon
  },
  props: {
    label: String,
    path: String,
    meta: String,
    title: String
  }
}
</script>

<template lang="html">
  <div class="ListingCard">
    <p class="ListingCard-label">{{ label }}</p>
    <a v-bind:href="path" class="ListingCard-title">
      {{ title }}<icon icon="go-arrow"></icon>
    </a>
    <p v-if="!!meta" class="ListingCard-meta">{{ meta }}</p>
    <a v-bind:href="path" class="ListingCard-link" aria-hidden="true" tabindex="-1"></a>
  </div>
</template>



// WEBPACK FOOTER //
// result.vue?5510ca34